import { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

// Coming-soon brand (Halwai / Bakery / Bodega): email capture only. No delivery badges — these brands are not on any app.
export function BrandOpeningNews({ business }) {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/locations/opening-news", { email, location_slug: `brand:${business.slug}` }); setDone(true); }
    catch (err) { toast.error(err.response?.data?.detail || "Please try again"); }
  };
  return (
    <section className="rounded-3xl bg-white border border-black/5 p-6 mt-8" data-testid="brand-opening-news">
      <h2 className="text-base md:text-lg font-extrabold">Hear when {business.name} opens</h2>
      <p className="text-sm text-neutral-700 mt-2">One email when ordering goes live. Nothing else.</p>
      {done ? (
        <p className="text-sm font-bold text-green-700 mt-4" data-testid="brand-opening-news-done">You're on the list — we'll email you when {business.name} opens.</p>
      ) : (
        <form onSubmit={submit} className="flex flex-wrap gap-2 mt-4">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email for opening news" data-testid="brand-opening-news-email"
            className="flex-1 min-w-[220px] h-10 rounded-full border border-neutral-300 px-4 text-sm" />
          <button type="submit" data-testid="brand-opening-news-submit" className="inline-flex items-center gap-2 bg-black text-white text-sm font-bold px-5 h-10 rounded-full hover:bg-neutral-800"><Mail size={14} /> Tell me when it opens</button>
        </form>
      )}
    </section>
  );
}
